'use strict';

const isAboveViewport = (element) => {
    const pageTop = $(window).scrollTop();
    const elementTop = $(element).offset().top;
    const elementBottom = elementTop + $(element).height();
    return pageTop >= elementBottom;
};

module.exports = isAboveViewport;
